import '../../App.css'
import '../../css/birth-entry.css'
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup"
import { yupResolver } from '@hookform/resolvers//yup'
import { useMutation, useQuery } from "@tanstack/react-query";
//import { useQuery, useMutation } from "@tanstack/react-query";
import Axios from "axios";
import { LocationInput } from "../../components/placeinput-nom";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, InputLabel, ListItemText, MenuItem, Radio, RadioGroup, Select, Stack, TextField, TextFieldProps, ThemeProvider, createTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
//import * as isLeapYear from 'dayjs/plugin/isLeapYear'


import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isLeapYear from 'dayjs/plugin/isLeapYear'
import { Fieldset } from '../../components/fieldset';
import { Chart } from '../../components/chart';
import { Today } from '@mui/icons-material';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isLeapYear)


interface Place {
    place_id: number;
    display_name: string;
    lat: string;
    lon: string;

  }

type FormData = {
    name: string;
    month: object,
    day: {day:string},
    year: {year:string},
    time: string;
    location: Place | null;
    chart_type: string;
    wheel_type: string;
    timezone: string
    solar_year: string;


}

//   const theme = createTheme({
//       components: {
//         // Name of the component

//         MuiAutocomplete: {
//           styleOverrides: {
//             // Name of the slot
//             root: {
//               "& .MuiAutocomplete-hasPopupIcon":{
//               // Some CSS
//               width:'33.33%', 
//             }
//           }
//         }
//     }
//     }
//   });

export const NewForm = (props:any) =>{


    const [ isVisible, setIsVisible] = useState(false)
    const [allowedToFetch, setAllowedToFetch] = useState(true)
    const [chartType, setChartType] = useState('');
    const [place, setPlace] = useState<Place | null>(null)

    const [selectedMonth, setSelectedMonth] = useState<{month: null | string, number: null | string}>({ month: null, number: null });
    const [selectedYear, setSelectedYear] = useState<{year: null | string}>({ year: null});
    const [selectedDay, setSelectedDay] = useState<{day: null | string}>({ day: null});
    const [selectedSolarYear, setSelectedSolarYear] = useState<string> ('');
    // const [biwheelChecked, setBiwheelChecked] = useState(false);
    // const [sideChecked, setSideChecked] = useState(false);
    const [wheelType, setWheelType] = useState('')
    const [checkState, setCheckState] = useState({biwheel: false, sidebyside:false}) 
    const { biwheel, sidebyside} = checkState
    const error = [biwheel, sidebyside].filter((value) => value).length > 1;
    
    const handleChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event)
        setCheckState({
          ...checkState,
          [event.target.name]: event.target.checked,
        });
        
      };
      console.log(checkState)

    // useImperativeHandle(ref, () => ({
        // setFieldValue: (name:any, value:any) => {
        //     console.log("I got the Imperative Handle")
        //     setValue(name, value, {shouldValidate: true});
        // },
        // childIsVisible:() => {setIsVisible(true)}
        // }));

    function daysArray (n: number) {
        let arr = []
        for (var val of Array.from(Array(n).keys())) {
            if (val === 0){continue}
            arr.push({"day": val.toString()})
        }
        return arr
    }

    function yearsArray(): any{ 
        let arr = []
        let n = dayjs().year() - 1900
        for (var val of Array.from(Array(n+101).keys()).map(i => i + 1900)){
            arr.push({"year": val.toString()})
            
        }
        return arr
    }

    function solarYearsArray(): any{ 
        let arr = []
        let n = dayjs().year() - 1900
        for (var val of Array.from(Array(n+101).keys()).map(i => i + 1900)){
            arr.push(val.toString())
        }
        return arr
    }

    const dates = [
        { month: "Jan", number: 1 },
        { month: "Feb", number: 2  },
        { month: "Mar" , number: 3 },
        { month: "Apr", number: 4},
        { month: "May", number: 5 },
        { month: "Jun", number: 6},
        { month: "Jul", number: 7},
        { month: "Aug", number: 8},
        { month: "Sep", number: 9},
        { month: "Oct", number: 10},
        { month: "Nov", number: 11},
        { month: "Dec", number: 12}
    ]

      const years = yearsArray()
      const solar_years = solarYearsArray()

    const filterOptions = () => {
        let dayOptions:{day:string}[] = []
        let n = 0

        if(selectedMonth.month == "Feb")
            if (selectedYear.year !== null)
                if(!(dayjs(selectedYear.year).isLeapYear()))
                    {n = 29}
                else{n=30}
            else {n=30}
        else
            switch(selectedMonth.month){
                case "Jan":
                    n = 32
                    break;
                case "Mar":
                    n = 32
                    break;
                case "Apr":
                    n = 31
                    break;
                case "May":
                    n = 32
                    break;
                case "Jun":
                    n = 31
                    break;
                case "Jul":
                    n = 32
                    break;
                case "Aug":
                    n = 32
                    break;
                case "Sep":
                    n = 31
                    break;
                case "Oct":
                    n = 32
                    break;
                case "Nov":
                    n = 31
                    break;
                case "Dec":
                    n = 32
                    break; 
                default:
                    n = 32

            }
        

        dayOptions = daysArray(n)
        return dayOptions
    }
    
    const leapYearError= () : boolean =>{

        if (selectedMonth.month === "Feb" && selectedYear.year !== null)
            if (!(dayjs(selectedYear.year).isLeapYear()) && selectedDay.day === "29")
                {return true}
            else
                {return false}
        else
            {return false}
        
        }

        const days = 
        //daysArray(32)
        filterOptions()

    

    const schema = yup.object().shape({
        name: yup.string().required(),
        month: yup.object().shape({
            month: yup.string(),
            number: yup.number()
          }),
        day: yup.object().shape({
            day: yup.string()
          }),
        year: yup.object().shape({
            year: yup.string()
          }),
        //date: yup.string().required(),
        time: yup.string().required(),
        // location: yup.mixed<Place>().required()
        chart_type: yup.string().required(),
        solar_year: yup.string()
    });

    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
        control
      } = useForm<FormData>({
        resolver: yupResolver(schema)
      });

    // function handleSetValue(){
    //     setValue('name', 'Dawn')
    // }

    const {data: geoname, error: err2, isLoading: load} = useQuery(
        {
        queryKey:['geoname', place?.lat, place?.lon],
        queryFn: () => getGeoName(),
        enabled: allowedToFetch && place?.lat !== undefined && place?.lon !== undefined
        }
    )
    
    // const getGeoName = () => fetch(`http://api.geonames.org/timezoneJSON?lat=${place?.lat}&lng=${place?.lon}&username=service.planetgazer`).then((res) => res.json())
    const getGeoName = () => fetch(`https://api.geoapify.com/v1/geocode/reverse?lat=${place?.lat}&lon=${place?.lon}&apiKey=${process.env.REACT_APP_GEOCODE_API_KEY}`)
                    .then((res) => res.json())
                    .then((data) => {
                        const timezone = data.features?.[0]?.properties?.timezone?.name;
                        return timezone;
                    })

    const { data: chart, isSuccess: successChart, mutate: mutateChart } = useMutation({

        mutationFn: (chartData: any) => 
            (process.env.NODE_ENV=='production') ?
            fetch(`https://api.planetgazer.net/chart`,
                {
                method:"POST",
                body: JSON.stringify(chartData),
                headers: {"Content-type": "application/json; charset=UTF-8"}
            }).then((res) => res.json())
            :
            fetch(`http://localhost:8000/chart`,
                {
                method:"POST",
                body: JSON.stringify(chartData),
                headers: {"Content-type": "application/json; charset=UTF-8"}
            }).then((res) => res.json())
            
    });

    const { data: custom, isSuccess: successCustom, mutate:mutateCustom } = useMutation({

        mutationFn: (chartData: any) => 
            (process.env.NODE_ENV=='production') ?
            fetch(`https://api.planetgazer.net/chart/${wheelType}/${chartData.chart_type}`,
                {
                method:"POST",
                body: JSON.stringify(chartData),
                headers: {"Content-type": "application/json; charset=UTF-8"}
            }).then((res) => res.json())
            :
            fetch(`http://localhost:8000/chart/${wheelType}/${chartData.chart_type}`,
                {
                method:"POST",
                body: JSON.stringify(chartData),
                headers: {"Content-type": "application/json; charset=UTF-8"}
            }).then((res) => res.json())
            
    });
    console.log(custom)

    const onSubmit = async (formData: FormData) => {
        
        props.setNewForm(false)
      
        if(checkState.biwheel){setWheelType('biwheel')}
        if(checkState.sidebyside){setWheelType('side-by-side')}
        const monthObj:any  = formData.month
        const dayObj:any = formData.day
        const yearObj:any = formData.year
        const time: any = formData.time

        const local_datetime = `${yearObj.year}-${monthObj.number}-${dayObj.day}T${time}:00` //no timezone- it is timezone independent
        const chartData = {name: formData.name, datetime: local_datetime, 
            // location: place, timezone: geoname?.timezoneId, chart_type: formData.chart_type.toLowerCase().replace(' ','_'),
            location: place, timezone: geoname, chart_type: formData.chart_type.toLowerCase().replace(' ','_'),
            solar_year: selectedSolarYear == '' ? '' : formData.solar_year 
        }
    
        console.log(formData)
        console.log(chartData);
        

        
        if(checkState.sidebyside){props.setDisplay({natal:false, sidebyside:true, biwheel:false}); await mutateCustom(chartData); props.setWheelType("side-by-side")}
           
        if(checkState.biwheel){props.setDisplay({natal:false, sidebyside:false, biwheel:true}); await mutateCustom(chartData); props.setWheelType("biwheel")}
            
        if(!checkState.biwheel && !checkState.sidebyside){
            if(selectedSolarYear==''){
                props.setDisplay({natal:true, solar_return: false, sidebyside:false, biwheel:false}); 
                }
            else{
                props.setDisplay({natal:false, solar_return: true, sidebyside:false, biwheel:false});
            }
            props.setWheelType("")
            await mutateChart(chartData)
        }
            
    }
    
    console.log(place)
    console.log(custom)
    console.log(chart)
    console.log(props.wheelType)


    useEffect(() => {

        let chart_date = dayjs(new Date())

        if (successChart){
            props.getSuccess()
            props.displayRef.current = props.display
            props.getChartSummary({
                name: chart?.info.name,
                location: chart?.info.location,
                utc: chart?.info.utc_datetime,
                utc_formatted: chart?.info.utc_formatted,
                natal_date: chart?.info.local_datetime,
                local_formatted: chart?.info.local_formatted,
                lat_formatted: chart?.info.lat_formatted,
                long_formatted: chart?.info.long_formatted,
                lat: chart?.info.lat,
                long: chart?.info.long,
                timezone: chart?.info.timezone,
                chart_type: chart?.info.chart_type,
                wheel_type: chart?.info.wheel_type            

        })
       
        chart_date = dayjs(chart?.info.local_datetime?.replace(/([+-]\d{2}:\d{2}|Z)$/, ""))
        console.log(chart?.info.name)
        

        if(chart.info.solar_return !== ""){
          
            props.getSolarReturnSummary({
                solar_return: chart?.info.solar_return,
                location: chart?.info.location,
                utc: chart?.info.solar_utc_datetime,
                utc_formatted:  chart?.info.solar_utc, 
                local: chart?.info.solar_formatted,
                solar_date: chart?.info.solar_date
            })
            chart_date = dayjs(chart?.info.solar_date?.replace(/([+-]\d{2}:\d{2}|Z)$/, ""))
            }
        
            
        if (props.ptid.current !== undefined || props.ptid.current !== null){
            props.ptid.current = chart?.info.utc_datetime
           }
        
        if (props.lat.current !== undefined || props.lat.current !== null){props.lat.current = chart?.info.lat}
        if (props.long.current !== undefined || props.long.current !== null){props.long.current = chart?.info.long}
        if (props.timezone.current !== undefined || props.timezone.current !== null){props.timezone.current = chart?.info.timezone}

        props.setDefaultDate(chart_date)
        console.log(chart_date)
        console.log(props.ptid.current)
        console.log("Latitude",props.lat.current, props.long.current)

        props.setDegreeSym('°')
        if (chart !== null || chart !== undefined)
        
        props.setSignVals({
            AriSignX: chart?.signs[0].coord[0],
            AriSignY: chart?.signs[0].coord[1],
            TauSignX: chart?.signs[1].coord[0],
            TauSignY: chart?.signs[1].coord[1],
            GemSignX: chart?.signs[2].coord[0],
            GemSignY: chart?.signs[2].coord[1],
            CanSignX: chart?.signs[3].coord[0],
            CanSignY: chart?.signs[3].coord[1],
            LeoSignX: chart?.signs[4].coord[0],
            LeoSignY: chart?.signs[4].coord[1],
            VirSignX: chart?.signs[5].coord[0],
            VirSignY: chart?.signs[5].coord[1],
            LibSignX: chart?.signs[6].coord[0],
            LibSignY: chart?.signs[6].coord[1],
            ScoSignX: chart?.signs[7].coord[0],
            ScoSignY: chart?.signs[7].coord[1],
            SagSignX: chart?.signs[8].coord[0],
            SagSignY: chart?.signs[8].coord[1],
            CapSignX: chart?.signs[9].coord[0],
            CapSignY: chart?.signs[9].coord[1],
            AquSignX: chart?.signs[10].coord[0],
            AquSignY: chart?.signs[10].coord[1],
            PisSignX: chart?.signs[11].coord[0],
            PisSignY: chart?.signs[11].coord[1]

        })

        chart?.planets.map((p: any) => { 


            if (p.planet == "Mo") {
                props.setMoVals({  
                    MoSym:"R", 
                    MoPlanetX: p.coord[0][0],
                    MoPlanetY: p.coord[0][1],
                    MoSign: p.sign,
                    MoSignSym: p.signSymbol,
                    MoSignX: p.coord[2][0],
                    MoSignY: p.coord[2][1],
                    MoDegree: p.degree,
                    MoDegreeX: p.coord[1][0],
                    MoDegreeY: p.coord[1][1],
                    MoMinute: p.minute,
                    MoMinuteX: p.coord[3][0],
                    MoMinuteY: p.coord[3][1],
                })
            }
            if (p.planet == "Me") { 
                props.setMeVals({
                    MeSym:"S",          
                    MePlanetX: p.coord[0][0],
                    MePlanetY: p.coord[0][1],
                    MeSign: p.sign,
                    MeSignSym: p.signSymbol,
                    MeSignX: p.coord[2][0],
                    MeSignY: p.coord[2][1],
                    MeDegree: p.degree,
                    MeDegreeX: p.coord[1][0],
                    MeDegreeY: p.coord[1][1],
                    MeMinute: p.minute,
                    MeMinuteX: p.coord[3][0],
                    MeMinuteY: p.coord[3][1],
                    MeRX:  p.rx,
                    MeRXX: p.coord[4][0],
                    MeRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ve") { 
                props.setVeVals({    
                    VeSym:"T",      
                    VePlanetX: p.coord[0][0],
                    VePlanetY: p.coord[0][1],
                    VeSign: p.sign,
                    VeSignSym: p.signSymbol,
                    VeSignX: p.coord[2][0],
                    VeSignY: p.coord[2][1],
                    VeDegree: p.degree,
                    VeDegreeX: p.coord[1][0],
                    VeDegreeY: p.coord[1][1],
                    VeMinute: p.minute,
                    VeMinuteX: p.coord[3][0],
                    VeMinuteY: p.coord[3][1],
                    VeRX:  p.rx,
                    VeRXX: p.coord[4][0],
                    VeRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Su") { 
                props.setSuVals({ 
                    SuSym:p.planetSymbol,         
                    SuPlanetX: p.coord[0][0],
                    SuPlanetY: p.coord[0][1],
                    SuSign: p.sign,
                    SuSignSym: p.signSymbol,
                    SuSignX: p.coord[2][0],
                    SuSignY: p.coord[2][1],
                    SuDegree: p.degree,
                    SuDegreeX: p.coord[1][0],
                    SuDegreeY: p.coord[1][1],
                    SuMinute: p.minute,
                    SuMinuteX: p.coord[3][0],
                    SuMinuteY: p.coord[3][1],
                    SuRX: p.coord[4][0],
                    SuRY: p.coord[4][1]
                })
            }
            
            if (p.planet == "Ma") { 
                props.setMaVals({
                    MaSym:"U",          
                    MaPlanetX: p.coord[0][0],
                    MaPlanetY: p.coord[0][1],
                    MaSign: p.sign,
                    MaSignSym: p.signSymbol,
                    MaSignX: p.coord[2][0],
                    MaSignY: p.coord[2][1],
                    MaDegree: p.degree,
                    MaDegreeX: p.coord[1][0],
                    MaDegreeY: p.coord[1][1],
                    MaMinute: p.minute,
                    MaMinuteX: p.coord[3][0],
                    MaMinuteY: p.coord[3][1],
                    MaRX: p.rx,
                    MaRXX: p.coord[4][0],
                    MaRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ju") { 
                props.setJuVals({ 
                    JuSym:"V",         
                    JuPlanetX: p.coord[0][0],
                    JuPlanetY: p.coord[0][1],
                    JuSign: p.sign,
                    JuSignSym: p.signSymbol,
                    JuSignX: p.coord[2][0],
                    JuSignY: p.coord[2][1],
                    JuDegree: p.degree,
                    JuDegreeX: p.coord[1][0],
                    JuDegreeY: p.coord[1][1],
                    JuMinute: p.minute,
                    JuMinuteX: p.coord[3][0],
                    JuMinuteY: p.coord[3][1],
                    JuRX: p.rx,
                    JuRXX: p.coord[4][0],
                    JuRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Sa") { 
                props.setSaVals({
                    SaSym:"W",          
                    SaPlanetX: p.coord[0][0],
                    SaPlanetY: p.coord[0][1],
                    SaSign: p.sign,
                    SaSignSym: p.signSymbol,
                    SaSignX: p.coord[2][0],
                    SaSignY: p.coord[2][1],
                    SaDegree: p.degree,
                    SaDegreeX: p.coord[1][0],
                    SaDegreeY: p.coord[1][1],
                    SaMinute: p.minute,
                    SaMinuteX: p.coord[3][0],
                    SaMinuteY: p.coord[3][1],
                    SaRX: p.rx,
                    SaRXX: p.coord[4][0],
                    SaRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ur") { 
                props.setUrVals({  
                    UrSym:"X",        
                    UrPlanetX: p.coord[0][0],
                    UrPlanetY: p.coord[0][1],
                    UrSign: p.sign,
                    UrSignSym: p.signSymbol,
                    UrSignX: p.coord[2][0],
                    UrSignY: p.coord[2][1],
                    UrDegree: p.degree,
                    UrDegreeX: p.coord[1][0],
                    UrDegreeY: p.coord[1][1],
                    UrMinute: p.minute,
                    UrMinuteX: p.coord[3][0],
                    UrMinuteY: p.coord[3][1],
                    UrRX: p.rx,
                    UrRXX: p.coord[4][0],
                    UrRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ne") { 
                props.setNeVals({  
                    NeSym:"Y",        
                    NePlanetX: p.coord[0][0],
                    NePlanetY: p.coord[0][1],
                    NeSign: p.sign,
                    NeSignSym: p.signSymbol,
                    NeSignX: p.coord[2][0],
                    NeSignY: p.coord[2][1],
                    NeDegree: p.degree,
                    NeDegreeX: p.coord[1][0],
                    NeDegreeY: p.coord[1][1],
                    NeMinute: p.minute,
                    NeMinuteX: p.coord[3][0],
                    NeMinuteY: p.coord[3][1],
                    NeRX: p.rx,
                    NeRXX: p.coord[4][0],
                    NeRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Pl") { 
                props.setPlVals({   
                    PlSym:"Z",       
                    PlPlanetX: p.coord[0][0],
                    PlPlanetY: p.coord[0][1],
                    PlSign: p.sign,
                    PlSignSym: p.signSymbol,
                    PlSignX: p.coord[2][0],
                    PlSignY: p.coord[2][1],
                    PlDegree: p.degree,
                    PlDegreeX: p.coord[1][0],
                    PlDegreeY: p.coord[1][1],
                    PlMinute: p.minute,
                    PlMinuteX: p.coord[3][0],
                    PlMinuteY: p.coord[3][1],
                    PlRX: p.rx,
                    PlRXX: p.coord[4][0],
                    PlRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ra") { 
                props.setRaVals({
                    RaSym:"<",          
                    RaPlanetX: p.coord[0][0],
                    RaPlanetY: p.coord[0][1],
                    RaSign: p.sign,
                    RaSignSym: p.signSymbol,
                    RaSignX: p.coord[2][0],
                    RaSignY: p.coord[2][1],
                    RaDegree: p.degree,
                    RaDegreeX: p.coord[1][0],
                    RaDegreeY: p.coord[1][1],
                    RaMinute: p.minute,
                    RaMinuteX: p.coord[3][0],
                    RaMinuteY: p.coord[3][1],
                    RaRX: p.rx,
                    RaRXX: p.coord[4][0],
                    RaRXY: p.coord[4][1],
                    RXSym: 'M' 
                })
            }
            if (p.planet == "Ke") { 
                props.setKeVals({ 
                    KeSym:">",         
                    KePlanetX: p.coord[0][0],
                    KePlanetY: p.coord[0][1],
                    KeSign: p.sign,
                    KeSignSym: p.signSymbol,
                    KeSignX: p.coord[2][0],
                    KeSignY: p.coord[2][1],
                    KeDegree: p.degree,
                    KeDegreeX: p.coord[1][0],
                    KeDegreeY: p.coord[1][1],
                    KeMinute: p.minute,
                    KeMinuteX: p.coord[3][0],
                    KeMinuteY: p.coord[3][1],
                    KeRX: p.rx,
                    KeRXX: p.coord[4][0],
                    KeRXY: p.coord[4][1]
                })
            }
            if (p.planet == "Ch") { 
                props.setChVals({  
                    ChSym:"t",        
                    ChPlanetX: p.coord[0][0],
                    ChPlanetY: p.coord[0][1],
                    ChSign: p.sign,
                    ChSignSym: p.signSymbol,
                    ChSignX: p.coord[2][0],
                    ChSignY: p.coord[2][1],
                    ChDegree: p.degree,
                    ChDegreeX: p.coord[1][0],
                    ChDegreeY: p.coord[1][1],
                    ChMinute: p.minute,
                    ChMinuteX: p.coord[3][0],
                    ChMinuteY: p.coord[3][1],
                    ChRX: p.rx,
                    ChRXX: p.coord[4][0],
                    ChRXY: p.coord[4][1]
                })
            }
            if (p.planet == "ASC") { 
                props.setASCVals({
                    ASCSym:"a",          
                    ASCPlanetX: p.coord[0][0],
                    ASCPlanetY: p.coord[0][1],
                    ASCSign: p.sign,
                    ASCSignSym: p.signSymbol,
                    ASCSignX: p.coord[2][0],
                    ASCSignY: p.coord[2][1],
                    ASCDegree: p.degree,
                    ASCDegreeX: p.coord[1][0],
                    ASCDegreeY: p.coord[1][1],
                    ASCMinute: p.minute,
                    ASCMinuteX: p.coord[3][0],
                    ASCMinuteY: p.coord[3][1]
                })

            }
            if (p.planet == "DSC") { 
                props.setDSCVals({
                    DSCSym:"DC",          
                    DSCPlanetX: p.coord[0][0],
                    DSCPlanetY: p.coord[0][1],
                    DSCSign: p.sign,
                    DSCSignSym: p.signSymbol,
                    DSCSignX: p.coord[2][0],
                    DSCSignY: p.coord[2][1],
                    DSCDegree: p.degree,
                    DSCDegreeX: p.coord[1][0],
                    DSCDegreeY: p.coord[1][1],
                    DSCMinute: p.minute,
                    DSCMinuteX: p.coord[3][0],
                    DSCMinuteY: p.coord[3][1]
                })
            }
            if (p.planet == "IC") { 
                props.setICVals({ 
                    ICSym:"c",         
                    ICPlanetX: p.coord[0][0],
                    ICPlanetY: p.coord[0][1],
                    ICSign: p.sign,
                    ICSignSym: p.signSymbol,
                    ICSignX: p.coord[2][0],
                    ICSignY: p.coord[2][1],
                    ICDegree: p.degree,
                    ICDegreeX: p.coord[1][0],
                    ICDegreeY: p.coord[1][1],
                    ICMinute: p.minute,
                    ICMinuteX: p.coord[3][0],
                    ICMinuteY: p.coord[3][1]
                })
            }
            if (p.planet == "MC") { 
                props.setMCVals({ 
                    MCSym:"b",         
                    MCPlanetX: p.coord[0][0],
                    MCPlanetY: p.coord[0][1],
                    MCSign: p.sign,
                    MCSignSym: p.signSymbol,
                    MCSignX: p.coord[2][0],
                    MCSignY: p.coord[2][1],
                    MCDegree: p.degree,
                    MCDegreeX: p.coord[1][0],
                    MCDegreeY: p.coord[1][1],
                    MCMinute: p.minute,
                    MCMinuteX: p.coord[3][0],
                    MCMinuteY: p.coord[3][1]
                })
            }
                if (p.planet == "LoFo") { 
                    props.setLoFoVals({ 
                        LoFoSym:";",         
                        LoFoPlanetX: p.coord[0][0],
                        LoFoPlanetY: p.coord[0][1],
                        LoFoSign: p.sign,
                        LoFoSignSym: p.signSymbol,
                        LoFoSignX: p.coord[2][0],
                        LoFoSignY: p.coord[2][1],
                        LoFoDegree: p.degree,
                        LoFoDegreeX: p.coord[1][0],
                        LoFoDegreeY: p.coord[1][1],
                        LoFoMinute: p.minute,
                        LoFoMinuteX: p.coord[3][0],
                        LoFoMinuteY: p.coord[3][1]
                    })
                }
            
    
        })
    }
    },[chart])

    useEffect(() => {

        let chart_date = dayjs(new Date())

        if (successCustom){
            props.getSuccessCustom(true)
            props.displayRef.current = props.display
            props.getChartSummary({
                name: custom?.info.name,
                location: custom?.info.location,
                utc: custom?.info.utc_datetime,
                utc_formatted: custom?.info.utc_formatted,
                natal_date: custom?.info.local_datetime,
                local_formatted: custom?.info.local_formatted,
                lat_formatted: custom?.info.lat_formatted,
                long_formatted: custom?.info.long_formatted,
                lat: custom?.info.lat,
                long: custom?.info.long,
                timezone: custom?.info.timezone,
                chart_type: custom?.info.chart_type,
                wheel_type: custom?.info.wheel_type
        })
    
        // props.ptid.current = custom?.info.utc_datettime

        if(!!custom.info.solar_return){
        
            props.getSolarReturnSummary({
                solar_return: custom?.info.solar_return,
                location: custom?.info.location,
                utc: custom?.info.solar_utc_datetime,
                utc_formatted: custom?.info.solar_utc,  
                local: custom?.info.solar_formatted,
                solar_date: custom?.info.solar_date
            })

            chart_date = dayjs(chart?.info.solar_date?.replace(/([+-]\d{2}:\d{2}|Z)$/, ""))
        }

        if (props.ptid.current !== undefined || props.ptid.current !== null){
            if (custom?.info.wheel_type == "biwheel"){
                props.ptid.current = custom?.info.utc_datetime
            }
            else{
            props.ptid.current = custom?.info.solar_utc_datetime
            }
        }

        if (props.lat.current !== undefined || props.lat.current !== null){props.lat.current = chart?.info.lat}
        if (props.long.current !== undefined || props.long.current !== null){props.long.current = chart?.info.long}
        if (props.timezone.current !== undefined || props.timezone.current !== null){props.timezone.current = chart?.info.timezone}

        props.setDefaultDate(chart_date)

        if (custom !== null || custom !== undefined){
        
        props.setSignVals({
            AriSignX: custom?.signs[0].inner_coord[0],
            AriSignY: custom?.signs[0].inner_coord[1],
            TauSignX: custom?.signs[1].inner_coord[0],
            TauSignY: custom?.signs[1].inner_coord[1],
            GemSignX: custom?.signs[2].inner_coord[0],
            GemSignY: custom?.signs[2].inner_coord[1],
            CanSignX: custom?.signs[3].inner_coord[0],
            CanSignY: custom?.signs[3].inner_coord[1],
            LeoSignX: custom?.signs[4].inner_coord[0],
            LeoSignY: custom?.signs[4].inner_coord[1],
            VirSignX: custom?.signs[5].inner_coord[0],
            VirSignY: custom?.signs[5].inner_coord[1],
            LibSignX: custom?.signs[6].inner_coord[0],
            LibSignY: custom?.signs[6].inner_coord[1],
            ScoSignX: custom?.signs[7].inner_coord[0],
            ScoSignY: custom?.signs[7].inner_coord[1],
            SagSignX: custom?.signs[8].inner_coord[0],
            SagSignY: custom?.signs[8].inner_coord[1],
            CapSignX: custom?.signs[9].inner_coord[0],
            CapSignY: custom?.signs[9].inner_coord[1],
            AquSignX: custom?.signs[10].inner_coord[0],
            AquSignY: custom?.signs[10].inner_coord[1],
            PisSignX: custom?.signs[11].inner_coord[0],
            PisSignY: custom?.signs[11].inner_coord[1]
        })


        props.setSignBVals({
            AriBSignX: custom?.signs[0].outer_coord[0],
            AriBSignY: custom?.signs[0].outer_coord[1],
            TauBSignX: custom?.signs[1].outer_coord[0],
            TauBSignY: custom?.signs[1].outer_coord[1],
            GemBSignX: custom?.signs[2].outer_coord[0],
            GemBSignY: custom?.signs[2].outer_coord[1],
            CanBSignX: custom?.signs[3].outer_coord[0],
            CanBSignY: custom?.signs[3].outer_coord[1],
            LeoBSignX: custom?.signs[4].outer_coord[0],
            LeoBSignY: custom?.signs[4].outer_coord[1],
            VirBSignX: custom?.signs[5].outer_coord[0],
            VirBSignY: custom?.signs[5].outer_coord[1],
            LibBSignX: custom?.signs[6].outer_coord[0],
            LibBSignY: custom?.signs[6].outer_coord[1],
            ScoBSignX: custom?.signs[7].outer_coord[0],
            ScoBSignY: custom?.signs[7].outer_coord[1],
            SagBSignX: custom?.signs[8].outer_coord[0],
            SagBSignY: custom?.signs[8].outer_coord[1],
            CapBSignX: custom?.signs[9].outer_coord[0],
            CapBSignY: custom?.signs[9].outer_coord[1],
            AquBSignX: custom?.signs[10].outer_coord[0],
            AquBSignY: custom?.signs[10].outer_coord[1],
            PisBSignX: custom?.signs[11].outer_coord[0],
            PisBSignY: custom?.signs[11].outer_coord[1]

        })
        

        custom?.planets.map((p: any) => { 

            if (p.planet == "Mo") {
                props.setMoVals({  
                    MoSym:"R", 
                    MoPlanetX: p.inner_coord[0][0],
                    MoPlanetY: p.inner_coord[0][1],
                    MoSign: p.inner_sign,
                    MoSignSym: p.inner_signSymbol,
                    MoSignX: p.inner_coord[2][0],
                    MoSignY: p.inner_coord[2][1],
                    MoDegree: p.inner_degree,
                    MoDegreeX: p.inner_coord[1][0],
                    MoDegreeY: p.inner_coord[1][1],
                    MoMinute: p.inner_minute,
                    MoMinuteX: p.inner_coord[3][0],
                    MoMinuteY: p.inner_coord[3][1]
                })
            }
            if (p.planet == "Mo") {
                props.setMoBVals({
                    MoBSym:"R",   
                    MoBPlanetX: p.outer_coord[0][0],
                    MoBPlanetY: p.outer_coord[0][1],
                    MoBSign: p.outer_sign,
                    MoBSignSym: p.outer_signSymbol,
                    MoBSignX: p.outer_coord[2][0],
                    MoBSignY: p.outer_coord[2][1],
                    MoBDegree: p.outer_degree,
                    MoBDegreeX: p.outer_coord[1][0],
                    MoBDegreeY: p.outer_coord[1][1],
                    MoBMinute: p.outer_minute,
                    MoBMinuteX: p.outer_coord[3][0],
                    MoBMinuteY: p.outer_coord[3][1],
                })
            }

            if (p.planet == "Me") { 
                props.setMeVals({
                    MeSym:"S",          
                    MePlanetX: p.inner_coord[0][0],
                    MePlanetY: p.inner_coord[0][1],
                    MeSign: p.inner_sign,
                    MeSignSym: p.inner_signSymbol,
                    MeSignX: p.inner_coord[2][0],
                    MeSignY: p.inner_coord[2][1],
                    MeDegree: p.inner_degree,
                    MeDegreeX: p.inner_coord[1][0],
                    MeDegreeY: p.inner_coord[1][1],
                    MeMinute: p.inner_minute,
                    MeMinuteX: p.inner_coord[3][0],
                    MeMinuteY: p.inner_coord[3][1],
                    MeRX:  p.inner_rx,
                    MeRXX: p.inner_coord[4][0],
                    MeRXY: p.inner_coord[4][1]
                })
            }    
                    
            if (p.planet == "Me") { 
                props.setMeBVals({
                    MeBSym:"S",       
                    MeBPlanetX: p.outer_coord[0][0],
                    MeBPlanetY: p.outer_coord[0][1],
                    MeBSign: p.outer_sign,
                    MeBSignSym: p.outer_signSymbol,
                    MeBSignX: p.outer_coord[2][0],
                    MeBSignY: p.outer_coord[2][1],
                    MeBDegree: p.outer_degree,
                    MeBDegreeX: p.outer_coord[1][0],
                    MeBDegreeY: p.outer_coord[1][1],
                    MeBMinute: p.outer_minute,
                    MeBMinuteX: p.outer_coord[3][0],
                    MeBMinuteY: p.outer_coord[3][1],
                    MeBRX:  p.outer_rx,
                    MeBRXX: p.outer_coord[4][0],
                    MeBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ve") { 
                props.setVeVals({    
                    VeSym:"T",      
                    VePlanetX: p.inner_coord[0][0],
                    VePlanetY: p.inner_coord[0][1],
                    VeSign: p.inner_sign,
                    VeSignSym: p.inner_signSymbol,
                    VeSignX: p.inner_coord[2][0],
                    VeSignY: p.inner_coord[2][1],
                    VeDegree: p.inner_degree,
                    VeDegreeX: p.inner_coord[1][0],
                    VeDegreeY: p.inner_coord[1][1],
                    VeMinute: p.inner_minute,
                    VeMinuteX: p.inner_coord[3][0],
                    VeMinuteY: p.inner_coord[3][1],
                    VeRX:  p.inner_rx,
                    VeRXX: p.inner_coord[4][0],
                    VeRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ve") { 
                props.setVeBVals({
                    VeBSym:"T",  
                    VeBPlanetX: p.outer_coord[0][0],
                    VeBPlanetY: p.outer_coord[0][1],
                    VeBSign: p.outer_sign,
                    VeBSignSym: p.outer_signSymbol,
                    VeBSignX: p.outer_coord[2][0],
                    VeBSignY: p.outer_coord[2][1],
                    VeBDegree: p.outer_degree,
                    VeBDegreeX: p.outer_coord[1][0],
                    VeBDegreeY: p.outer_coord[1][1],
                    VeBMinute: p.outer_minute,
                    VeBMinuteX: p.outer_coord[3][0],
                    VeBMinuteY: p.outer_coord[3][1],
                    VeBRX:  p.outer_rx,
                    VeBRXX: p.outer_coord[4][0],
                    VeBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Su") { 
                props.setSuVals({ 
                    SuSym: 'Q',         
                    SuPlanetX: p.inner_coord[0][0],
                    SuPlanetY: p.inner_coord[0][1],
                    SuSign: p.inner_sign,
                    SuSignSym: p.inner_signSymbol,
                    SuSignX: p.inner_coord[2][0],
                    SuSignY: p.inner_coord[2][1],
                    SuDegree: p.inner_degree,
                    SuDegreeX: p.inner_coord[1][0],
                    SuDegreeY: p.inner_coord[1][1],
                    SuMinute: p.inner_minute,
                    SuMinuteX: p.inner_coord[3][0],
                    SuMinuteY: p.inner_coord[3][1],
                    SuRX: p.inner_coord[4][0],
                    SuRY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Su") { 
                props.setSuBVals({ 
                    SuBSym: 'Q',  
                    SuBPlanetX: p.outer_coord[0][0],
                    SuBPlanetY: p.outer_coord[0][1],
                    SuBSign: p.outer_sign,
                    SuBSignSym: p.outer_signSymbol,
                    SuBSignX: p.outer_coord[2][0],
                    SuBSignY: p.outer_coord[2][1],
                    SuBDegree: p.outer_degree,
                    SuBDegreeX: p.outer_coord[1][0],
                    SuBDegreeY: p.outer_coord[1][1],
                    SuBMinute: p.outer_minute,
                    SuBMinuteX: p.outer_coord[3][0],
                    SuBMinuteY: p.outer_coord[3][1],
                    SuBRX: p.outer_coord[4][0],
                    SuBRY: p.outer_coord[4][1]
                })
            }
            
            if (p.planet == "Ma") { 
                props.setMaVals({
                    MaSym:"U",          
                    MaPlanetX: p.inner_coord[0][0],
                    MaPlanetY: p.inner_coord[0][1],
                    MaSign: p.inner_sign,
                    MaSignSym: p.inner_signSymbol,
                    MaSignX: p.inner_coord[2][0],
                    MaSignY: p.inner_coord[2][1],
                    MaDegree: p.inner_degree,
                    MaDegreeX: p.inner_coord[1][0],
                    MaDegreeY: p.inner_coord[1][1],
                    MaMinute: p.inner_minute,
                    MaMinuteX: p.inner_coord[3][0],
                    MaMinuteY: p.inner_coord[3][1],
                    MaRX: p.inner_rx,
                    MaRXX: p.inner_coord[4][0],
                    MaRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ma") { 
                props.setMaBVals({
                    MaBSym:"U",
                    MaBPlanetX: p.outer_coord[0][0],
                    MaBPlanetY: p.outer_coord[0][1],
                    MaBSign: p.outer_sign,
                    MaBSignSym: p.outer_signSymbol,
                    MaBSignX: p.outer_coord[2][0],
                    MaBSignY: p.outer_coord[2][1],
                    MaBDegree: p.outer_degree,
                    MaBDegreeX: p.outer_coord[1][0],
                    MaBDegreeY: p.outer_coord[1][1],
                    MaBMinute: p.outer_minute,
                    MaBMinuteX: p.outer_coord[3][0],
                    MaBMinuteY: p.outer_coord[3][1],
                    MaBRX: p.outer_rx,
                    MaBRXX: p.outer_coord[4][0],
                    MaBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ju") { 
                props.setJuVals({ 
                    JuSym:"V",         
                    JuPlanetX: p.inner_coord[0][0],
                    JuPlanetY: p.inner_coord[0][1],
                    JuSign: p.inner_sign,
                    JuSignSym: p.inner_signSymbol,
                    JuSignX: p.inner_coord[2][0],
                    JuSignY: p.inner_coord[2][1],
                    JuDegree: p.inner_degree,
                    JuDegreeX: p.inner_coord[1][0],
                    JuDegreeY: p.inner_coord[1][1],
                    JuMinute: p.inner_minute,
                    JuMinuteX: p.inner_coord[3][0],
                    JuMinuteY: p.inner_coord[3][1],
                    JuRX: p.inner_rx,
                    JuRXX: p.inner_coord[4][0],
                    JuRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ju") { 
                props.setJuBVals({ 
                    JuBSym:"V", 
                    JuBPlanetX: p.outer_coord[0][0],
                    JuBPlanetY: p.outer_coord[0][1],
                    JuBSign: p.outer_sign,
                    JuBSignSym: p.outer_signSymbol,
                    JuBSignX: p.outer_coord[2][0],
                    JuBSignY: p.outer_coord[2][1],
                    JuBDegree: p.outer_degree,
                    JuBDegreeX: p.outer_coord[1][0],
                    JuBDegreeY: p.outer_coord[1][1],
                    JuBMinute: p.outer_minute,
                    JuBMinuteX: p.outer_coord[3][0],
                    JuBMinuteY: p.outer_coord[3][1],
                    JuBRX: p.outer_rx,
                    JuBRXX: p.outer_coord[4][0],
                    JuBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Sa") { 
                props.setSaVals({
                    SaSym:"W",          
                    SaPlanetX: p.inner_coord[0][0],
                    SaPlanetY: p.inner_coord[0][1],
                    SaSign: p.inner_sign,
                    SaSignSym: p.inner_signSymbol,
                    SaSignX: p.inner_coord[2][0],
                    SaSignY: p.inner_coord[2][1],
                    SaDegree: p.inner_degree,
                    SaDegreeX: p.inner_coord[1][0],
                    SaDegreeY: p.inner_coord[1][1],
                    SaMinute: p.inner_minute,
                    SaMinuteX: p.inner_coord[3][0],
                    SaMinuteY: p.inner_coord[3][1],
                    SaRX: p.inner_rx,
                    SaRXX: p.inner_coord[4][0],
                    SaRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Sa") { 
                props.setSaBVals({ 
                    SaBSym:"W",  
                    SaBPlanetX: p.outer_coord[0][0],
                    SaBPlanetY: p.outer_coord[0][1],
                    SaBSign: p.outer_sign,
                    SaBSignSym: p.outer_signSymbol,
                    SaBSignX: p.outer_coord[2][0],
                    SaBSignY: p.outer_coord[2][1],
                    SaBDegree: p.outer_degree,
                    SaBDegreeX: p.outer_coord[1][0],
                    SaBDegreeY: p.outer_coord[1][1],
                    SaBMinute: p.outer_minute,
                    SaBMinuteX: p.outer_coord[3][0],
                    SaBMinuteY: p.outer_coord[3][1],
                    SaBRX: p.outer_rx,
                    SaBRXX: p.outer_coord[4][0],
                    SaBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ur") { 
                props.setUrVals({  
                    UrSym:"X",        
                    UrPlanetX: p.inner_coord[0][0],
                    UrPlanetY: p.inner_coord[0][1],
                    UrSign: p.inner_sign,
                    UrSignSym: p.inner_signSymbol,
                    UrSignX: p.inner_coord[2][0],
                    UrSignY: p.inner_coord[2][1],
                    UrDegree: p.inner_degree,
                    UrDegreeX: p.inner_coord[1][0],
                    UrDegreeY: p.inner_coord[1][1],
                    UrMinute: p.inner_minute,
                    UrMinuteX: p.inner_coord[3][0],
                    UrMinuteY: p.inner_coord[3][1],
                    UrRX: p.inner_rx,
                    UrRXX: p.inner_coord[4][0],
                    UrRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ur") { 
                props.setUrBVals({ 
                    UrBSym:"X", 
                    UrBPlanetX: p.outer_coord[0][0],
                    UrBPlanetY: p.outer_coord[0][1],
                    UrBSign: p.outer_sign,
                    UrBSignSym: p.outer_signSymbol,
                    UrBSignX: p.outer_coord[2][0],
                    UrBSignY: p.outer_coord[2][1],
                    UrBDegree: p.outer_degree,
                    UrBDegreeX: p.outer_coord[1][0],
                    UrBDegreeY: p.outer_coord[1][1],
                    UrBMinute: p.outer_minute,
                    UrBMinuteX: p.outer_coord[3][0],
                    UrBMinuteY: p.outer_coord[3][1],
                    UrBRX: p.outer_rx,
                    UrBRXX: p.outer_coord[4][0],
                    UrBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ne") { 
                props.setNeVals({  
                    NeSym:"Y",        
                    NePlanetX: p.inner_coord[0][0],
                    NePlanetY: p.inner_coord[0][1],
                    NeSign: p.inner_sign,
                    NeSignSym: p.inner_signSymbol,
                    NeSignX: p.inner_coord[2][0],
                    NeSignY: p.inner_coord[2][1],
                    NeDegree: p.inner_degree,
                    NeDegreeX: p.inner_coord[1][0],
                    NeDegreeY: p.inner_coord[1][1],
                    NeMinute: p.inner_minute,
                    NeMinuteX: p.inner_coord[3][0],
                    NeMinuteY: p.inner_coord[3][1],
                    NeRX: p.inner_rx,
                    NeRXX: p.inner_coord[4][0],
                    NeRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ne") { 
                props.setNeBVals({
                    NeBSym:"Y",   
                    NeBPlanetX: p.outer_coord[0][0],
                    NeBPlanetY: p.outer_coord[0][1],
                    NeBSign: p.outer_sign,
                    NeBSignSym: p.outer_signSymbol,
                    NeBSignX: p.outer_coord[2][0],
                    NeBSignY: p.outer_coord[2][1],
                    NeBDegree: p.outer_degree,
                    NeBDegreeX: p.outer_coord[1][0],
                    NeBDegreeY: p.outer_coord[1][1],
                    NeBMinute: p.outer_minute,
                    NeBMinuteX: p.outer_coord[3][0],
                    NeBMinuteY: p.outer_coord[3][1],
                    NeBRX: p.outer_rx,
                    NeBRXX: p.outer_coord[4][0],
                    NeBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Pl") { 
                props.setPlVals({   
                    PlSym:"Z",       
                    PlPlanetX: p.inner_coord[0][0],
                    PlPlanetY: p.inner_coord[0][1],
                    PlSign: p.inner_sign,
                    PlSignSym: p.inner_signSymbol,
                    PlSignX: p.inner_coord[2][0],
                    PlSignY: p.inner_coord[2][1],
                    PlDegree: p.inner_degree,
                    PlDegreeX: p.inner_coord[1][0],
                    PlDegreeY: p.inner_coord[1][1],
                    PlMinute: p.inner_minute,
                    PlMinuteX: p.inner_coord[3][0],
                    PlMinuteY: p.inner_coord[3][1],
                    PlRX: p.inner_rx,
                    PlRXX: p.inner_coord[4][0],
                    PlRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Pl") { 
                props.setPlBVals({
                    PlBSym:"Z",    
                    PlBPlanetX: p.outer_coord[0][0],
                    PlBPlanetY: p.outer_coord[0][1],
                    PlBSign: p.outer_sign,
                    PlBSignSym: p.outer_signSymbol,
                    PlBSignX: p.outer_coord[2][0],
                    PlBSignY: p.outer_coord[2][1],
                    PlBDegree: p.outer_degree,
                    PlBDegreeX: p.outer_coord[1][0],
                    PlBDegreeY: p.outer_coord[1][1],
                    PlBMinute: p.outer_minute,
                    PlBMinuteX: p.outer_coord[3][0],
                    PlBMinuteY: p.outer_coord[3][1],
                    PlBRX: p.outer_rx,
                    PlBRXX: p.outer_coord[4][0],
                    PlBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ra") { 
                props.setRaVals({
                    RaSym:"<",          
                    RaPlanetX: p.inner_coord[0][0],
                    RaPlanetY: p.inner_coord[0][1],
                    RaSign: p.inner_sign,
                    RaSignSym: p.inner_signSymbol,
                    RaSignX: p.inner_coord[2][0],
                    RaSignY: p.inner_coord[2][1],
                    RaDegree: p.inner_degree,
                    RaDegreeX: p.inner_coord[1][0],
                    RaDegreeY: p.inner_coord[1][1],
                    RaMinute: p.inner_minute,
                    RaMinuteX: p.inner_coord[3][0],
                    RaMinuteY: p.inner_coord[3][1],
                    RaRX: p.inner_rx,
                    RaRXX: p.inner_coord[4][0],
                    RaRXY: p.inner_coord[4][1],
                    RXSym: 'M'
                })
            }
            if (p.planet == "Ra") { 
                props.setRaBVals({
                    RaBSym:"<",
                    RaBPlanetX: p.outer_coord[0][0],
                    RaBPlanetY: p.outer_coord[0][1],
                    RaBSign: p.outer_sign,
                    RaBSignSym: p.outer_signSymbol,
                    RaBSignX: p.outer_coord[2][0],
                    RaBSignY: p.outer_coord[2][1],
                    RaBDegree: p.outer_degree,
                    RaBDegreeX: p.outer_coord[1][0],
                    RaBDegreeY: p.outer_coord[1][1],
                    RaBMinute: p.outer_minute,
                    RaBMinuteX: p.outer_coord[3][0],
                    RaBMinuteY: p.outer_coord[3][1],
                    RaBRX: p.outer_rx,
                    RaBRXX: p.outer_coord[4][0],
                    RaBRXY: p.outer_coord[4][1],
                    RXBSym: 'M'  
                })
            }
            if (p.planet == "Ke") { 
                props.setKeVals({ 
                    KeSym:">",         
                    KePlanetX: p.inner_coord[0][0],
                    KePlanetY: p.inner_coord[0][1],
                    KeSign: p.inner_sign,
                    KeSignSym: p.inner_signSymbol,
                    KeSignX: p.inner_coord[2][0],
                    KeSignY: p.inner_coord[2][1],
                    KeDegree: p.inner_degree,
                    KeDegreeX: p.inner_coord[1][0],
                    KeDegreeY: p.inner_coord[1][1],
                    KeMinute: p.inner_minute,
                    KeMinuteX: p.inner_coord[3][0],
                    KeMinuteY: p.inner_coord[3][1],
                    KeRX: p.inner_rx,
                    KeRXX: p.inner_coord[4][0],
                    KeRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ke") { 
                props.setKeBVals({
                    KeSym:">",
                    KeBPlanetX: p.outer_coord[0][0],
                    KeBPlanetY: p.outer_coord[0][1],  
                    KeBSign: p.outer_sign,
                    KeBSignSym: p.outer_signSymbol,
                    KeBSignX: p.outer_coord[2][0],
                    KeBSignY: p.outer_coord[2][1],
                    KeBDegree: p.outer_degree,
                    KeBDegreeX: p.outer_coord[1][0],
                    KeBDegreeY: p.outer_coord[1][1],
                    KeBMinute: p.outer_minute,
                    KeBMinuteX: p.outer_coord[3][0],
                    KeBMinuteY: p.outer_coord[3][1],
                    KeBRX: p.outer_rx,
                    KeBRXX: p.outer_coord[4][0],
                    KeBRXY: p.outer_coord[4][1]
                })
            }
            if (p.planet == "Ch") { 
                props.setChVals({  
                    ChSym:"t",        
                    ChPlanetX: p.inner_coord[0][0],
                    ChPlanetY: p.inner_coord[0][1],
                    ChSign: p.inner_sign,
                    ChSignSym: p.inner_signSymbol,
                    ChSignX: p.inner_coord[2][0],
                    ChSignY: p.inner_coord[2][1],
                    ChDegree: p.inner_degree,
                    ChDegreeX: p.inner_coord[1][0],
                    ChDegreeY: p.inner_coord[1][1],
                    ChMinute: p.inner_minute,
                    ChMinuteX: p.inner_coord[3][0],
                    ChMinuteY: p.inner_coord[3][1],
                    ChRX: p.inner_rx,
                    ChRXX: p.inner_coord[4][0],
                    ChRXY: p.inner_coord[4][1]
                })
            }
            if (p.planet == "Ch") { 
                props.setChBVals({
                    ChBSym:"t",    
                    ChBPlanetX: p.outer_coord[0][0],
                    ChBPlanetY: p.outer_coord[0][1],
                    ChBSign: p.outer_sign,
                    ChBSignSym: p.outer_signSymbol,
                    ChBSignX: p.outer_coord[2][0],
                    ChBSignY: p.outer_coord[2][1],
                    ChBDegree: p.outer_degree,
                    ChBDegreeX: p.outer_coord[1][0],
                    ChBDegreeY: p.outer_coord[1][1],
                    ChBMinute: p.outer_minute,
                    ChBMinuteX: p.outer_coord[3][0],
                    ChBMinuteY: p.outer_coord[3][1],
                    ChBRX: p.outer_rx,
                    ChBRXX: p.outer_coord[4][0],
                    ChBRXY: p.outer_coord[4][1]
                    
                })
            }
            if (p.planet == "ASC") { 
                props.setASCVals({
                    ASCSym:"a",          
                    ASCPlanetX: p.inner_coord[0][0],
                    ASCPlanetY: p.inner_coord[0][1],
                    ASCSign: p.inner_sign,
                    ASCSignSym: p.inner_signSymbol,
                    ASCSignX: p.inner_coord[2][0],
                    ASCSignY: p.inner_coord[2][1],
                    ASCDegree: p.inner_degree,
                    ASCDegreeX: p.inner_coord[1][0],
                    ASCDegreeY: p.inner_coord[1][1],
                    ASCMinute: p.inner_minute,
                    ASCMinuteX: p.inner_coord[3][0],
                    ASCMinuteY: p.inner_coord[3][1]
                })
            }
            if (p.planet == "ASC") { 
                props.setASCBVals({
                    ASCBSym:"a",   
                    ASCBPlanetX: p.outer_coord[0][0],
                    ASCBPlanetY: p.outer_coord[0][1],
                    ASCBSign: p.outer_sign,
                    ASCBSignSym: p.outer_signSymbol,
                    ASCBSignX: p.outer_coord[2][0],
                    ASCBSignY: p.outer_coord[2][1],
                    ASCBDegree: p.outer_degree,
                    ASCBDegreeX: p.outer_coord[1][0],
                    ASCBDegreeY: p.outer_coord[1][1],
                    ASCBMinute: p.outer_minute,
                    ASCBMinuteX: p.outer_coord[3][0],
                    ASCBMinuteY: p.outer_coord[3][1]
                })

            }
            if (p.planet == "DSC") { 
                props.setDSCVals({
                    DSCSym:"DC",          
                    DSCPlanetX: p.inner_coord[0][0],
                    DSCPlanetY: p.inner_coord[0][1],
                    DSCSign: p.inner_sign,
                    DSCSignSym: p.inner_signSymbol,
                    DSCSignX: p.inner_coord[2][0],
                    DSCSignY: p.inner_coord[2][1],
                    DSCDegree: p.inner_degree,
                    DSCDegreeX: p.inner_coord[1][0],
                    DSCDegreeY: p.inner_coord[1][1],
                    DSCMinute: p.inner_minute,
                    DSCMinuteX: p.inner_coord[3][0],
                    DSCMinuteY: p.inner_coord[3][1]
                })
            }
            if (p.planet == "DSC") { 
                props.setDSCBVals({
                    DSCBSym:"DC",   
                    DSCBPlanetX: p.outer_coord[0][0],
                    DSCBPlanetY: p.outer_coord[0][1],
                    DSCBSign: p.outer_sign,
                    DSCBSignSym: p.outer_signSymbol,
                    DSCBSignX: p.outer_coord[2][0],
                    DSCBSignY: p.outer_coord[2][1],
                    DSCBDegree: p.outer_degree,
                    DSCBDegreeX: p.outer_coord[1][0],
                    DSCBDegreeY: p.outer_coord[1][1],
                    DSCBMinute: p.outer_minute,
                    DSCBMinuteX: p.outer_coord[3][0],
                    DSCBMinuteY: p.outer_coord[3][1]
                })
            }
            if (p.planet == "IC") { 
                props.setICVals({ 
                    ICSym:"c",         
                    ICPlanetX: p.inner_coord[0][0],
                    ICPlanetY: p.inner_coord[0][1],
                    ICSign: p.inner_sign,
                    ICSignSym: p.inner_signSymbol,
                    ICSignX: p.inner_coord[2][0],
                    ICSignY: p.inner_coord[2][1],
                    ICDegree: p.inner_degree,
                    ICDegreeX: p.inner_coord[1][0],
                    ICDegreeY: p.inner_coord[1][1],
                    ICMinute: p.inner_minute,
                    ICMinuteX: p.inner_coord[3][0],
                    ICMinuteY: p.inner_coord[3][1],
                    
                })
            }
            if (p.planet == "IC") { 
                props.setICBVals({
                    ICBSym:"c",  
                    ICBPlanetX: p.outer_coord[0][0],
                    ICBPlanetY: p.outer_coord[0][1],
                    ICBSign: p.outer_sign,
                    ICBSignSym: p.outer_signSymbol,
                    ICBSignX: p.outer_coord[2][0],
                    ICBSignY: p.outer_coord[2][1],
                    ICBDegree: p.outer_degree,
                    ICBDegreeX: p.outer_coord[1][0],
                    ICBDegreeY: p.outer_coord[1][1],
                    ICBMinute: p.outer_minute,
                    ICBMinuteX: p.outer_coord[3][0],
                    ICBMinuteY: p.outer_coord[3][1]
                })
            }
            if (p.planet == "MC") { 
                props.setMCVals({ 
                    MCSym:"b",         
                    MCPlanetX: p.inner_coord[0][0],
                    MCPlanetY: p.inner_coord[0][1],
                    MCSign: p.inner_sign,
                    MCSignSym: p.inner_signSymbol,
                    MCSignX: p.inner_coord[2][0],
                    MCSignY: p.inner_coord[2][1],
                    MCDegree: p.inner_degree,
                    MCDegreeX: p.inner_coord[1][0],
                    MCDegreeY: p.inner_coord[1][1],
                    MCMinute: p.inner_minute,
                    MCMinuteX: p.inner_coord[3][0],
                    MCMinuteY: p.inner_coord[3][1]
                })
            }
            if (p.planet == "MC") { 
                props.setMCBVals({ 
                    MCBPlanetX: p.outer_coord[0][0],
                    MCBPlanetY: p.outer_coord[0][1],
                    MCBSign: p.outer_sign,
                    MCBSignSym: p.outer_signSymbol,
                    MCBSignX: p.outer_coord[2][0],
                    MCBSignY: p.outer_coord[2][1],
                    MCBDegree: p.outer_degree,
                    MCBDegreeX: p.outer_coord[1][0],
                    MCBDegreeY: p.outer_coord[1][1],
                    MCBMinute: p.outer_minute,
                    MCBMinuteX: p.outer_coord[3][0],
                    MCBMinuteY: p.outer_coord[3][1]
                })
            }

            if (p.planet == "LoFo") { 
                props.setLoFoVals({ 
                    LoFoSym:";",         
                    LoFoPlanetX: p.inner_coord[0][0],
                    LoFoPlanetY: p.inner_coord[0][1],
                    LoFoSign: p.inner_sign,
                    LoFoSignSym: p.inner_signSymbol,
                    LoFoSignX: p.inner_coord[2][0],
                    LoFoSignY: p.inner_coord[2][1],
                    LoFoDegree: p.inner_degree,
                    LoFoDegreeX: p.inner_coord[1][0],
                    LoFoDegreeY: p.inner_coord[1][1],
                    LoFoMinute: p.inner_minute,
                    LoFoMinuteX: p.inner_coord[3][0],
                    LoFoMinuteY: p.inner_coord[3][1]
                })
            }
            if (p.planet == "LoFo") { 
                props.setLoFoBVals({ 
                    LoFoBPlanetX: p.outer_coord[0][0],
                    LoFoBPlanetY: p.outer_coord[0][1],
                    LoFoBSign: p.outer_sign,
                    LoFoBSignSym: p.outer_signSymbol,
                    LoFoBSignX: p.outer_coord[2][0],
                    LoFoBSignY: p.outer_coord[2][1],
                    LoFoBDegree: p.outer_degree,
                    LoFoBDegreeX: p.outer_coord[1][0],
                    LoFoBDegreeY: p.outer_coord[1][1],
                    LoFoBMinute: p.outer_minute,
                    LoFoBMinuteX: p.outer_coord[3][0],
                    LoFoBMinuteY: p.outer_coord[3][1]
                })
            }


        })
        }
        }
        },[custom])

    console.log(props.display)
    console.log(props.displayRef.current)
    console.log("Latitude",props.lat.current, props.long.current)

    return (
        <>
        {/* <ThemeProvider theme={theme}> */}
        {/* <FormControl onSubmit={handleSubmit(onSubmit)} sx={{width: '35%', m:2}}> */}
        <form onSubmit={handleSubmit(onSubmit)}>
            <TextField className="newForm" label="Name/Event" required {...register("name")} InputLabelProps={{ shrink: true }}  sx={{ my: 4, width: '100%'}}/>
            <Fieldset className='date-group'
                title={"Date"}
                titleSize="0.75rem"
                borderColor="initial"
                color = "rgba(0, 0, 0, 0.6)"
                sx ={{p:3, width:'100%'}}
            >
                    <Controller 
                        name="month"
                        control={control}
                        
                        render={({field: { ref, ...fieldProps }}) =>  (
                            <Autocomplete  
                                disableClearable
                                getOptionLabel={(date) => date.month }
                                options={dates}
                                isOptionEqualToValue={(option, value) => option.month === value.month}
                                sx={{ "& :hover .MuiAutocomplete-input, & .Mui-focused .MuiAutocomplete-input": { minWidth: "30px" }, width: '100%' }}
                                // defaultValue={ { month: "February", number: 2  }}
                                renderInput={(params) => 
                                    <TextField {...params} label="Month"
                                    required 
                                    
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ }}
                                    
                            />}
                                onChange={(e, newValue:any) => {
                                    setSelectedMonth(newValue)
                                    fieldProps.onChange(newValue)
                                }}
                            
                            />
                        )}
                        />
                    <Controller 
                        name="day"
                        control={control}
                        
                        render={({field: { ref, ...fieldProps }}) =>  (
                   
                            <Autocomplete 
                                {...fieldProps}
                                disableClearable
                                options={days}
                                isOptionEqualToValue={(option, value) => option.day === value.day}
                                getOptionLabel={(day) => day.day}
                                //filterOptions={filterOptions}
                                sx={{ "& :hover .MuiAutocomplete-input, & .Mui-focused .MuiAutocomplete-input": { minWidth: "30px" } }}
                                //isOptionEqualToValue={(option, selectedMonth) => option.month === selectedMonth.month}
                        //         renderOption={(props, option) => (
                        //             <li {...props} key={option.day}>
                        //               <ListItemText>{option.day}</ListItemText>
                        //             </li>
                        //   )}
                                renderInput={(params) => 
                                    <TextField {...params} label="Day"
                                    required 
                                    //fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    sx={{marginTop:"20px"}}
                                    error={leapYearError()}
                                    helperText={leapYearError() ? "Invalid date" : ""}
                                    />}
                                onChange={(e, newValue:any) => {
                                    setSelectedDay(newValue)
                                    fieldProps.onChange(newValue)
                                 }}
                                />
                            )}
                            />
                    <Controller 
                        name="year"
                        control={control}
                        
                        render={({field: { ref, ...fieldProps }}) =>  (
                   
                            <Autocomplete  
                                {...fieldProps}
                                filterSelectedOptions
                                disableClearable
                                options={years}
                                getOptionLabel={(year) => year.year }
                                isOptionEqualToValue={(option, value) => option.year === value.year}
                                sx={{ "& :hover .MuiAutocomplete-input, & .Mui-focused .MuiAutocomplete-input": { minWidth: "30px" }, width: '100%' }}
                                renderInput={(params) => 
                                    <TextField {...params} label="Year"
                                    required 
                                    //fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    sx={{marginTop:"20px"}}

                                    />}
                                onChange={(e, newValue:any) => {
                                    setSelectedYear(newValue)
                                    fieldProps.onChange(newValue)
                                }}
                                
                            />
                        )}
                        />
               
            </Fieldset>
            <TextField type="time" label="Time" required placeholder="Time" {...register("time")}
            InputLabelProps={{ shrink: true }}
            sx={{ width:'100%', my: 5}}
            /> 
            
            <Controller 
             name="location"
             control={control}
             
             render={({field: { ref, ...fieldProps }}) =>  (
                <LocationInput 
                //{...register("location")}
                
                inputRef={ref}
                {...fieldProps}
                setPlace={setPlace}
                />
                
                    )}
            
           
             />
       
             <Controller 
             name="chart_type"
             control={control}
            render={({field: { ref, ...fieldProps }}) =>  (
            <FormControl sx={{ my: 4, width:'100%'}} placeholder="Select"  id="form-control-chart" >
            <InputLabel shrink id="chart-type-label">Chart Type</InputLabel>
            <Select
            required 
            notched 
            displayEmpty
            inputRef={ref}
            {...fieldProps}
            id="chart-type"
            value={chartType}
            label="Chart Type"
            onChange={(event: any) => {
                setChartType(event.target.value)
                if(event.target.value == 'Natal'){setSelectedSolarYear(''); setCheckState({biwheel:false, sidebyside:false});}
            
                fieldProps.onChange(event.target.value)
                //console.log(biwheelChecked)
                
            }}
            renderValue={(value) => (value ? <span>{value}</span> : <span style={{color: 'rgb(150, 150, 150'}}>Select</span>)}
            
        >
            <MenuItem value={"Natal"}>Natal</MenuItem>
            <MenuItem value={"Solar Return"}>Solar Return</MenuItem>

        </Select>
        </FormControl>
            )}
            
           
            />
        <Controller 
            name="solar_year"
            control={control}
            
            render={({field: { ref, ...fieldProps }}) =>  (
        
                <Autocomplete  
                    {...fieldProps}
                    filterSelectedOptions
                    disableClearable
                    options={solar_years}
                    value={selectedSolarYear}
                    getOptionLabel={(year) => year }
                    isOptionEqualToValue={(option, value) => option === value}
                    sx={{ my: 2, width:'100%', display: chartType == 'Solar Return' ? 'block' : 'none'}}
                    //sx={{ "& :hover .MuiAutocomplete-input, & .Mui-focused .MuiAutocomplete-input": { minWidth: "30px" }, width: '30%' }}
                    renderInput={(params) => 
                        <TextField {...params} label="Solar Year"
                        required={chartType=='Solar Return' ? true : false}
                        //fullWidth
                        InputLabelProps={{ shrink: true }}
                        //sx={{}}

                        />}
                    onChange={(e, newValue:any) => {
                        setSelectedSolarYear(newValue)
                        fieldProps.onChange(newValue)
                    }}
                    
                />
            )}
            />
        <div style={{display: chartType == 'Solar Return' ? 'block' : 'none'}}>
        <FormControl style={{color: 'rgba(0,0,0,.70)'}} className='custom-display' component="fieldset" error={error} sx={{ mt: 3, ml: 1}}>Custom Display:
        <FormControlLabel control={<Checkbox
        name = 'biwheel'
        sx={{ p:'5px', ml:2, my:1}}
        onChange={(event: any) => {
            //if(event.target.checked){setBiwheelChecked(true); setWheelType('biwheel')}else{setBiwheelChecked(false)}
            handleChecked(event)
        }}
        
        checked={biwheel}
        />} label="Biwheel" />

        <FormControlLabel control={<Checkbox
        name='sidebyside'
        sx={{ p:'5px', ml:2}}
        onChange={(event: any) => {
            // if(event.target.checked){setSideChecked(true); setWheelType('side-by-side')}else{setSideChecked(false)}
            handleChecked(event)
            
        }}
        
        checked={sidebyside}
        />} label="Side By Side" />
        </FormControl>
        <FormHelperText  sx={{ ml: 1}} style={{display: error ? 'block' : 'none', color: 'red'}}>Select only one option</FormHelperText>
        </div>
        <div style={{ marginTop: '2rem' }}>
        {props.editForm &&
        <Button 
        onClick = {()=>{
            props.setEditForm(false)
            props.setNewForm(false)
            props.setDisplay(props.displayRef.current)
        }}
        sx={{ m: 1, width:'20%'}} variant="outlined">Cancel</Button>}
        {/* style={{ display: isVisible ?  'inline-flex':  'none'  }} */}
        <Button sx={{ m: 1, width:'20%'}} type="submit" variant="contained" color="primary" disabled={error}>Go</Button>
        </div>
        
        
        </form>
        {/* <Button 
        onClick={handleSetValue}
        variant="text">Edit Chart</Button>
        </ThemeProvider> */}
        
        </>
        )}
    
    
        

        // <FormControl>
        //     <FormLabel>Custom Display</FormLabel>
        //     <RadioGroup
        //         aria-labelledby="display-radio-buttons-group"
        //         //value={value}
        //         onChange={(event: any) =>{
        //             if(event.target.value=='biwheel'){setBiwheelChecked(true); setSideChecked(false);setWheelType('biwheel')}else{setSideChecked(true);setBiwheelChecked(false)}}
        //         }
        //     >
        //         <FormControlLabel value="biwheel" control={<Radio />} label="Biwheel" />
        //         <FormControlLabel value="side by side" control={<Radio />} label="Side by Side" />
        //     </RadioGroup>
        // </FormControl>
    // const dates = [
    //     { month: "January", day: Array.from(Array(1,31).keys()) },
    //     { month: "February", day: Array.from(Array(1,28+1).keys()) },
    //     { month: "March", day: Array.from(Array(1,31).keys()) },
    //     { month: "April", day: Array.from(Array(1,30).keys()) },
    //   ];

    /*const {register, handleSubmit} = useForm<FormData>({
        resolver: yupResolver(schema)
    });


    
       
    // const {data: chart, error, isLoading} = useQuery(
    //     { 
    //     queryKey: ['chart'],
    //     queryFn: () => loadPlanets(),
    //     enabled: !!ipq && !!geoloc && allowedToFetch
    //     });
    
    // const loadPlanets = () =>
    //     fetch(`http://localhost/api/chart/?date=${utc_datetime}&dst=${dst}&lat=${lat.current}&long=${long.current}`).then((res) => res.json()
    // )


    // const newChartMutation = useMutation({
    //     mutationFn: (chartData: FormData) => {
    //         return Axios.post("http://localhost/api/api/v1/getchart/", chartData).then((res) => console.log(res.data))
    //     },

    // });

    if(newChartMutation.isLoading){
        return <div>Loading...</div>
    }


    if(chartQuery.isError){
        return <pre>{JSON.stringify(chartQuery.error)}</pre>
    }

    function wait(duration: any){
        return new Promise(resolve => setTimeout(resolve, duration))
      }

    const chartQuery = useQuery({
        {  data, isLoading }
        queryKey: ["newchart"],
        queryFn: () => {
        return Axios.get("http://localhost/api").then((res) => console.log(res.data[1][0].description));
        return Axios.get("http://localhost/api").then((res) => res.data[1][0])
}});*/

